import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-electricalstability-vertical',
  standalone: false,
  templateUrl: './electricalstability-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class ElectricalstabilityVerticalComponent{
@Input() electricalstabilitTest:any;
}
